import React from 'react';
import PropTypes from 'prop-types';
import MaterialDivider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';

function Divider({ marginTop, marginBottom }) {
  const styles = () => ({
    divider: {
      marginTop,
      marginBottom,
      color: '#E9ECED',
    },
  });

  const divider = ({ classes }) => (
    <MaterialDivider className={classes.divider} />
  );

  divider.propTypes = {
    classes: PropTypes.object,
  };

  const StyledDivider = withStyles(styles)(divider);
  return <StyledDivider />;
}

Divider.propTypes = {
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
};

Divider.defaultProps = {
  marginTop: 20,
  marginBottom: 20,
};

export default Divider;
